import { isSameId } from "../../helpers";
import { tempID } from "@wx/lib-state";
export default function (store, { id, card, select }) {
    const { cards, columnKey } = store.getState();
    const cardToCopy = cards.find(card => isSameId(card.id, id));
    if (cardToCopy) {
        const newCard = {
            ...cardToCopy,
            id: tempID(),
            ...(card || {}),
        };
        store.in.exec("add-card", {
            columnId: newCard[columnKey],
            before: id,
            card: newCard,
            select,
        });
    }
}
//# sourceMappingURL=duplicate.js.map